import React, { Component } from 'react';
import './news.css';
import SideBar from './sidebar';
import Features from '../features/features';
import FeatPrinciples from '../features/feat1/feat1';

import SinglePost from './singlepost';
import {Switch, Route } from 'react-router-dom';

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {                  
        };
      }

    componentDidMount() {
       
      }
    
      // Retrieves the list of items from the Express app
 
    render() {
        
        return (
            <React.Fragment>
                <div className="newsMainStage fullStage relative">
                <Switch>
                    <Route path="/features/:id" render={()=><FeatPrinciples/>} />
                    <Route path="/news/:id" render={()=><SinglePost/>} />
                    <Route path='/' render={()=><Features/>} />
                </Switch>
                     <Route exact path='/' render={()=><SideBar/>} />
                </div>
            </React.Fragment>
        )
    }
  }
  
  export default News;






// WEBPACK FOOTER //
// ./src/components/news/news.js